import React from 'react';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import { isImage } from 'utils/validate';
import { t } from 'i18next';
import images from 'assets/images';

const ReactstrapImageUpload = ({
    field: { ...fields },
    form: { touched, errors, setFieldValue, setFieldTouched },
    isVideoFile,
    ...props
}) => {
    const { id, dimensionProps, fileName, ...rest } = props;
    const fileStyle = props.disabled ? { opacity: '0' } : { width: '60%', display: 'inline-block' };
    const uniqueId = Math.random().toString();

    const displayFile = () => {
        if (fields.value && !_.isString(fields.value)) {
            let imgsrc = URL.createObjectURL(fields.value);
            return (
                <div className="d-flex pl-2 align-items-center mt-2">
                    <div className="preview-div">
                        <img src={imgsrc} alt="" className="preview-div-img" />
                    </div>
                    <div className="ml-2 width-20px">
                        <a
                            href="#"
                            className="icon"
                            title={t('removeImage')}
                            onClick={(e) => {
                                e.preventDefault();
                                setFieldValue(fields.name, '');
                                props.forceUpdate();
                            }}
                        >
                            <img src={images.deleteSVG} alt={t('removeImage')} />
                        </a>
                    </div>
                </div>
            );
        }
        if (!_.isEmpty(fields.value) && _.isString(fields.value) && isVideoFile) {
            return (
                <div>
                    <span className="d-block text-truncate" title={fields.value}>
                        {fields.value}
                    </span>
                </div>
            );
        }
        if (!_.isEmpty(fields.value) && _.isString(fields.value) && isImage(fields.value)) {
            return (
                <div className="d-flex pl-2 align-items-center mt-2 ">
                    <div className="preview-div">
                        <img
                            style={{ maxHeight: '40px', maxWidth: '40px' }}
                            src={`${process.env.REACT_APP_DRIVER_PORTAL_URL}/${fields.value}`}
                            alt=""
                        />
                    </div>
                    <div style={{ width: '20px' }} className="ml-2">
                        <a
                            href="#"
                            className="icon"
                            title={t('removeImage')}
                            onClick={(e) => {
                                e.preventDefault();
                                setFieldValue(fields.name, '');
                                props.forceUpdate();
                            }}
                        >
                            <img src={images.deleteSVG} alt={t('removeImage')} />
                        </a>
                    </div>
                </div>
            );
        }
        if (!_.isEmpty(fields.value) && _.isString(fields.value)) {
            return (
                <a
                    style={{ textDecoration: 'underline', color: '#007bff' }}
                    href={`${process.env.REACT_APP_DRIVER_PORTAL_URL}/${fields.value}`}
                    target="__black"
                >
                    {fileName}
                </a>
            );
        }
        return '';
    };
    return (
        <Form.Group controlId={id} className="form-group">
            <div className="form-file d-flex flex-column">
                <label className="form-file-label">{rest.label}</label>
                <Form.Control
                    {...rest}
                    type="file"
                    className="form-control-file custom-file-class"
                    style={fileStyle}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                    onChange={(e) => {
                        setFieldTouched(fields.name, true);
                        if ((e.currentTarget as any).files[0]) {
                            setFieldValue(fields.name, (e.currentTarget as any).files[0]);
                        } else {
                            setFieldValue(fields.name, '');
                        }
                    }}
                    onBlur={() => {
                        setFieldTouched(fields.name, true);
                    }}
                    id={`files-${uniqueId}`}
                />
            </div>
            <div
                className="file-row"
                style={
                    props.disabled
                        ? { background: '#f2f2f2', padding: '10px', alignItems: 'center' }
                        : { alignItems: 'center' }
                }
            >
                <label
                    title={t('ChooseFile')}
                    htmlFor={`files-${uniqueId}`}
                    style={props.disabled ? { pointerEvents: 'none' } : {}}
                    className="file-input"
                >
                    {t('ChooseFile')}
                </label>
                <span className="mt-1">{fields.value.name ? fields.value.name : t('noFileChosen')}</span>
                {displayFile()}
            </div>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapImageUpload;
